import { render, staticRenderFns } from "./GInput.vue?vue&type=template&id=898b728a&scoped=true&"
import script from "./GInput.vue?vue&type=script&lang=js&"
export * from "./GInput.vue?vue&type=script&lang=js&"
import style0 from "./GInput.vue?vue&type=style&index=0&id=898b728a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898b728a",
  null
  
)

export default component.exports